import type { ShareOrDownloadOptions } from './types.js';

/** Keep the blob URL alive long enough for the browser to start the download. */
const DOWNLOAD_BLOB_REVOKE_MS = 1000;

export type DownloadBlobLocallyOptions = Pick<ShareOrDownloadOptions, 'filename'> & {
  readonly mimeType?: string;
};

/**
 * Force a local `<a download>` save. Never calls `navigator.share`
 * (QR label wizard Download CTA — R8 / G4).
 */
export function downloadBlobLocally(blob: Blob, options: DownloadBlobLocallyOptions): void {
  const url = URL.createObjectURL(blob);
  const dl = document.createElement('a');
  dl.href = url;
  dl.download = options.filename;
  dl.click();
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, DOWNLOAD_BLOB_REVOKE_MS);
}
